import connect from 'react-redux/es/connect/connect';

import ConfirmationPage from '../components/ConfirmationPage';

const mapStateToProps = state => {
    return {
        customer: state.user.customer,
        createResult: state.cart.success
    };
};

export default connect(mapStateToProps, () => ({}))(ConfirmationPage);
